"use strict";

exports.__esModule = true;
var _DashboardElement = require("./DashboardElement");
Object.keys(_DashboardElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardElement[key]) return;
  exports[key] = _DashboardElement[key];
});
var _DashboardFields = require("./DashboardFields");
Object.keys(_DashboardFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardFields[key]) return;
  exports[key] = _DashboardFields[key];
});
var _EditableDashboardElement = require("./EditableDashboardElement");
Object.keys(_EditableDashboardElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableDashboardElement[key]) return;
  exports[key] = _EditableDashboardElement[key];
});
var _DashboardWidgetThumbnail = require("./DashboardWidgetThumbnail");
Object.keys(_DashboardWidgetThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardWidgetThumbnail[key]) return;
  exports[key] = _DashboardWidgetThumbnail[key];
});
var _DashboardHeader = require("./DashboardHeader");
Object.keys(_DashboardHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardHeader[key]) return;
  exports[key] = _DashboardHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});